import visualize from "javascript-state-machine/lib/visualize";
import StateMachine from "javascript-state-machine";

const generateVisualizationObject = (fsm) => {
    return visualize(fsm);
};

const restore = (fromFsm, state) => {
    const { initialState, future, history } = state;

    const fsm = new StateMachine({
        ...fromFsm._fsm.config.options,
        init: initialState
    });

    if (history) {
        fsm.history.splice(0, fsm.history.length);
        history.forEach((item) => fsm.history.push(item));
    }

    if (future) {
        fsm.future.splice(0, fsm.future.length);
        future.forEach((item) => fsm.future.push(item));
    }

    return fsm;
};

const startsAt = (transition, state) => {
    return (
        transition.from === state ||
        (Array.isArray(transition.from) && transition.from.includes(state))
    );
};

const endsAt = (transition, state) => {
    return transition.to === state;
};

const getTransitionFromStates = (fsm, fromState, toState) => {
    const transitions = fsm._fsm.config.options.transitions.filter(
        (t) => startsAt(t, fromState) && endsAt(t, toState)
    );

    if (transitions.length > 1) {
        throw new Error(
            `More than one transition is defined between state ${fromState} and ${toState}`
        );
    }

    return transitions.length ? transitions[0] : null;
};

const getTransition = (fsm, transitionName) => {
    const transitions = fsm._fsm.config.options.transitions.filter(
        (t) => t.name === transitionName
    );

    if (transitions.length > 1) {
        throw new Error(
            `More than one transition is defined with the name ${transitionName}`
        );
    }

    return transitions.length ? transitions[0] : null;
};

export {
    generateVisualizationObject,
    restore,
    getTransitionFromStates,
    getTransition
};
